//
import dashbord from '../pages/dashboard/setting.json'
import bank from '../pages/bank/setting.json'
import bank_account from '../pages/bank_account/setting.json'
import box from '../pages/box/setting.json'
import person from '../pages/person/setting.json'
import product from '../pages/product/setting.json'
import invoice from '../pages/doc/invoice/invoiceSetting.json'
import lending from '../pages/doc/lending/lendingSetting.json'
import receipt from '../pages/doc/rp/receiptSetting.json'
import payment from '../pages/doc/rp/paymentSetting.json'
import cheque from '../pages/cheque/setting.json'
import cost from '../pages/cost/setting.json'
import income from '../pages/income/setting.json'
import transfer from '../pages/transfer/setting.json'
import balance from '../pages/reports/balances/setting.json'
import daily from '../pages/dashboard/setting.json'
import bank_bill from '../pages/bank_bill/setting.json'
import bank_control from '../pages/bank_control/setting.json'
import fiscal_year from '../pages/fiscal_year/setting.json'
import role from '../pages/role/setting.json'
import user from '../pages/user/setting.json'

const PageInfoModule = {
  getters: {
    pageInfo(state, getters, rootState) {
      // console.log(rootState.route.path.split("/")[1])
      let baseRoute = rootState.route.path.split("/")[1]
      if (baseRoute === '') {
        return dashbord
      } else if (baseRoute === 'banks') {
        return bank
      } else if (baseRoute === 'bank_accounts') {
        return bank_account
      } else if (baseRoute === 'boxes') {
        return box
      } else if (baseRoute === 'persons') {
        return person
      } else if (baseRoute === 'products') {
        return product
      } else if (baseRoute === 'invoices') {
        return invoice
      } else if (baseRoute === 'lendings') {
        return lending
      } else if (baseRoute === 'receipts') {
        return receipt
      } else if (baseRoute === 'payments') {
        return payment
      } else if (baseRoute === 'cheques') {
        return cheque
      } else if (baseRoute === 'costs') {
        return cost
      } else if (baseRoute === 'incomes') {
        return income
      } else if (baseRoute === 'transfers') {
        return transfer
      } else if (baseRoute === 'balances') {
        return balance
      } else if (baseRoute === 'reports') { //daily
        return daily
      } else if (baseRoute === 'bank_bill') {
        return bank_bill
      } else if (baseRoute === 'bank_control') {
        return bank_control
      } else if (baseRoute === 'fiscal_years') {
        return fiscal_year
      } else if (baseRoute === 'roles') {
        return role
      } else if (baseRoute === 'users') {
        return user
      }
    }
  }
}

export default PageInfoModule
